import React from 'react';
import { WebsiteDesignProps } from './types';
import { Rocket, Star, Globe } from 'lucide-react';
import { Button } from "@/components/ui/button";

const SpaceExplorer: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Galactic Academy";

    return (
        <div className="bg-[#020617] text-white min-h-screen font-sans overflow-hidden relative">
            {/* Stars */}
            <div className="absolute inset-0 z-0" style={{backgroundImage: 'radial-gradient(white 1px, transparent 1px)', backgroundSize: '50px 50px', opacity: 0.2}}></div>
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-[#020617] z-10"></div>
            
            {/* Planet */}
            <div className="absolute -bottom-[40vw] -right-[10vw] w-[80vw] h-[80vw] bg-blue-600 rounded-full blur-[100px] opacity-20 z-0"></div>

            <nav className="relative z-20 p-8 flex justify-between items-center">
                 <div className="text-2xl font-bold tracking-widest flex items-center gap-2">
                     <div className="bg-white text-black p-1 rounded-full"><Rocket size={20} /></div> {schoolName}
                 </div>
                 <Button variant="ghost" className="text-blue-200 hover:text-white hover:bg-white/10">Launch Portal</Button>
            </nav>

            <main className="relative z-20 container mx-auto px-8 pt-20 flex flex-col items-center text-center">
                 <div className="mb-4 text-blue-300 tracking-[0.5em] text-sm uppercase font-bold animate-pulse">Scanning Horizon...</div>
                 <h1 className="text-6xl md:text-9xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-b from-white to-blue-900 tracking-tighter">
                     EXPLORE <br/> THE UNKNOWN
                 </h1>
                 <p className="text-lg md:text-xl text-blue-200 max-w-2xl mb-12">
                     Preparing the next generation of astronauts, engineers, and dreamers. Your journey to the stars begins in the classroom.
                 </p>
                 
                 <Button className="h-16 px-12 rounded-full bg-white text-black font-bold text-lg hover:bg-blue-50 shadow-[0_0_50px_rgba(255,255,255,0.3)] transition-all hover:scale-105">
                     Initiate Application
                 </Button>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-32 w-full max-w-6xl">
                     <div className="bg-[#0f172a]/50 border border-blue-900/50 p-8 rounded-2xl backdrop-blur-sm hover:bg-[#0f172a]/80 transition-colors">
                         <Star className="w-10 h-10 text-yellow-400 mb-4" />
                         <h3 className="text-xl font-bold mb-2">Stellar Faculty</h3>
                         <p className="text-blue-400 text-sm">Learn from potential Nobel laureates and field experts.</p>
                     </div>
                     <div className="bg-[#0f172a]/50 border border-blue-900/50 p-8 rounded-2xl backdrop-blur-sm hover:bg-[#0f172a]/80 transition-colors">
                         <Globe className="w-10 h-10 text-blue-400 mb-4" />
                         <h3 className="text-xl font-bold mb-2">Universal Reach</h3>
                         <p className="text-blue-400 text-sm">Our alumni are leading innovation across the globe.</p>
                     </div>
                     <div className="bg-[#0f172a]/50 border border-blue-900/50 p-8 rounded-2xl backdrop-blur-sm hover:bg-[#0f172a]/80 transition-colors">
                         <Rocket className="w-10 h-10 text-red-400 mb-4" />
                         <h3 className="text-xl font-bold mb-2">Propulsion Labs</h3>
                         <p className="text-blue-400 text-sm">World-class facilities for physics and engineering.</p>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default SpaceExplorer;
